// extracted by mini-css-extract-plugin
module.exports = {"btn":"PostCommunity_btn__2l62-"};